import { useEffect } from "react";

export const MENU_OPEN_EVENT = "solventum:menu-open";

export const emitMenuOpen = (id) => {
  if (typeof document === "undefined") return;
  document.dispatchEvent(
    new CustomEvent(MENU_OPEN_EVENT, { detail: { id } })
  );
};

export const useMenuAutoClose = (id, isOpen, buttonRef) => {
  useEffect(() => {
    const handler = (event) => {
      if (!event?.detail) return;
      if (event.detail.id !== id && isOpen) {
        if (buttonRef.current && typeof buttonRef.current.click === "function") {
          buttonRef.current.click();
        }
      }
    };
    document.addEventListener(MENU_OPEN_EVENT, handler);
    return () => document.removeEventListener(MENU_OPEN_EVENT, handler);
  }, [id, isOpen, buttonRef]);
};
